import React, { useContext, useEffect, useState, useRef } from "react";
import { Link, Routes, useParams, useNavigate } from "react-router-dom";
import ImageWithBasePath from "../core/common/imageWithBasePath";
import { all_routes } from "./router/all_routes";
import Header from "./Header";
import { ProductContext } from "../context/AppContext";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import { KJUR } from "jsrsasign";

const Myregistration = () => {
  const params = useParams();
  const [state, setState] = useState(null);
  const navigate = useNavigate();
  const {
    allClass = [],
    dataNew,
    getRegistration,
    setGetRegistration,
    fetchMyReegistrationData,
    GetstudentData,
    userData,
    Automationdata,
  } = useContext(ProductContext);
  const authtoken = localStorage.getItem("token");
const [isDownloading, setIsDownloading] = useState(false);

  const routes = all_routes;
  const { id } = useParams();

  const [classData, setClassData] = useState([]);

  useEffect(() => {
    const fetchClassData = async () => {
      try {
        const response = await fetch(
          "https://api.mirai.healthcare/api/masters/classes"
        );
        const result = await response.json();
        if (response.ok) {
          setClassData(result.data);
        }
      } catch (error) {
        console.error("Error fetching class data:", error);
      }
    };

    fetchClassData();
  }, []);

  useEffect(() => {
    fetchMyReegistrationData();
  }, [authtoken]);

  let dateOfBirth;
  if (getRegistration?.data?.date_of_birth) {
    const parsedDate = new Date(getRegistration.data.date_of_birth);
    if (!isNaN(parsedDate)) {
      dateOfBirth = parsedDate.toISOString().split("T")[0];
    } else {
      console.error("Invalid date format:", getRegistration.data.date_of_birth);
      dateOfBirth = null;
    }
  } else {
    console.error("Date of birth is undefined or null");
    dateOfBirth = null;
  }

  const { registrationId } = useParams();
  // const navigate = useNavigate();
  const [razorpayKey, setRazorpayKey] = useState("");
  const rzpRef = useRef(null);
  // const authtoken = localStorage.getItem('token');

  const fetchRazorpayKey = async () => {
    try {
      const response = await fetch(
        "https://api.mirai.healthcare/api/payment/registration/key",
        {
          method: "GET",
          headers: {
            "x-auth": `${authtoken}`,
            "Content-Type": "application/json",
          },
        }
      );
      const result = await response.json();
      if (result.success && result.message?.data?.key) {
        setRazorpayKey(result.message.data.key);
        return result.message.data.key;
      } else {
        console.error("Failed to fetch Razorpay key");
        return null;
      }
    } catch (error) {
      console.error("Error fetching key:", error);
      return null;
    }
  };

  const createPaymentOrder = async (razorpayKey) => {
    try {
      const response = await fetch(
        "https://api.mirai.healthcare/api/payment/registration",
        {
          method: "POST",
          headers: {
            "x-auth": `${authtoken}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            registration_id: getRegistration?.data?.id,
            amount: 100000,
          }),
        }
      );
      const result = await response.json();

      if (result.success && result.message?.paymentRes) {
        const { id: order_id } = result.message.paymentRes;
        loadRazorpay(razorpayKey, order_id);
      } else {
        console.error("Failed to create payment order");
      }
    } catch (error) {
      console.error("Error creating payment order:", error);
    }
  };

  const verifyPayment = async (paymentData) => {
    try {
      const response = await fetch(
        "https://api.mirai.healthcare/api/payment/registration/verify",
        {
          method: "POST",
          headers: {
            "x-auth": `${authtoken}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            razorpay_payment_id: paymentData.razorpay_payment_id,
            razorpay_order_id: paymentData.razorpay_order_id,
            registration_id: getRegistration?.data?.id,
            razorpay_signature: paymentData.razorpay_signature,
          }),
        }
      );

      const result = await response.json();
      if (result.success) {
        console.log("Payment verification successful:", result);

        alert("Payment Successful!");
        fetchMyReegistrationData();

        setTimeout(() => {
          navigate("/registration");
        }, 1000);
      } else {
        alert("Payment verification failed");
      }
    } catch (error) {
      console.error("Error verifying payment:", error);
    }
  };

  const loadRazorpay = (razorpayKey, order_id) => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    document.body.appendChild(script);

    script.onload = () => {
      const options = {
        key: razorpayKey,
        amount: 100000, // 1000 INR
        currency: "INR",
        name: "School App",
        description: "Registration Payment",
        order_id: order_id,
        handler: function (response) {
          console.log("Payment success response:", response);
          verifyPayment(response);
        },
        modal: {
          ondismiss: function () {
            console.log("Payment modal dismissed.");
            navigate("/registration");
          },
        },
        prefill: {
          name: "John Doe",
          email: "johndoe@example.com",
          contact: "9999999999",
        },
        theme: {
          color: "#3399cc",
        },
      };

      rzpRef.current = new window.Razorpay(options);
      rzpRef.current.open();
    };
  };

  const handlePayment = async () => {
    const key = await fetchRazorpayKey();
    if (key) {
      createPaymentOrder(key);
    }
  };

  const ClassdataNew = {
    class: Number(dataNew?.class),
  };

  const ClassLabel = allClass
    .filter((item) => item.value === ClassdataNew.class)
    .map((item) => item.label)[0];

  const className =
    classData.find(
      (cls) => cls.id === parseInt(getRegistration?.data?.select_class)
    )?.Classes;

   const handleDownloadPDF = async () => {
  try {
    setIsDownloading(true); // show loader
    const button = document.querySelector(".no-print");
    const input = document.getElementById("enquiry-content");

    // Hide download button before capture
    button.style.display = "none";

    // Wait a short delay to ensure all images/text are loaded
    await new Promise((resolve) => setTimeout(resolve, 1000));

    const canvas = await html2canvas(input, {
      scale: 2,
      useCORS: true, // ensures images from URLs are captured properly
      logging: false,
    });

    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF("p", "mm", "a4");

    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
    pdf.save(`Registration_${getRegistration?.data?.student_full_name || "Data"}.pdf`);

    // Restore button after download
    button.style.display = "inline-block";
  } catch (error) {
    console.error("PDF generation error:", error);
  } finally {
    setIsDownloading(false); // hide loader
  }
};

const StudentMobilePayment = getRegistration?.data?.father_mobile_no || getRegistration?.data?.mother_mobile_no || getRegistration?.data?.guardian_mobile_no;
const StudentEmailPayment = getRegistration?.data?.father_email || getRegistration?.data?.mother_email || getRegistration?.data?.guardian_email;

const schema = userData?.currentUser?.schema;

const generateJwtToken = (schema) => {
    const header = { alg: "HS256", typ: "JWT" };
    const payload = {
      schema: schema,
      exp: Math.floor(Date.now() / 1000) + (30 * 60),
    };
    const sHeader = JSON.stringify(header);
    const sPayload = JSON.stringify(payload);
    const token = KJUR.jws.JWS.sign("HS256", sHeader, sPayload, "token");
    return token;
  };


const handleOnlinePayment = () => {
    if (!getRegistration?.data?.id || !schema) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Missing registration ID or schema'
      });
      return;
    }

    const paymentData = {
      registrationId: getRegistration?.data?.id,
      schema: schema,
      amount: Automationdata?.data?.[0]?.registration_fee,
      firstname: getRegistration?.data?.student_full_name,
      email: StudentEmailPayment,
      phone: StudentMobilePayment,
      paymentMethod: Automationdata?.data?.[0]?.PaymentMethod,
    };

    // console.log(paymentData, "paymentData Print")

    const base64Data = btoa(JSON.stringify(paymentData));
    const jwtToken = generateJwtToken(schema);
    // console.log(jwtToken, "jwtToken print");
    // console.log(base64Data, "base64Data Print")
    const queryParams = new URLSearchParams({
      data: base64Data,
      authToken: jwtToken,
    });

    // console.log(paymentData, "paymentData Payment")
    // const paymentUrl = `https://admin.mirai.healthcare/pay-u-payment?${queryParams.toString()}`;
    const paymentUrl = `${window.location.origin}/pay-u-payment?${queryParams.toString()}`;

    window.open(paymentUrl, '_blank');
    // console.log(paymentUrl, "Payment after click paymentUrl")
  };


    



  return (
    <>
      <div className="page-wrapper">
        {getRegistration ? (
          <div className="content">
            <Header />
            <div className="row">
              <div className="col-md-12">
                <div className="d-md-flex d-block align-items-center justify-content-between">
                  <div className="my-auto mb-1 mt-3 mb-3" style={{width:'100%'}}>
                    <h2
              className="page-title fw-bold mb-0"
              style={{ letterSpacing: "0.5px" }}>
  Registration Details
  <span style={{float:'right'}}>
   
{/* {getRegistration?.data?.pri_application_status  !== "Validate" && getRegistration?.data?.is_admitted === true (
    <Link
  to="/updateregistration"
  state={{ getRegistration }}
  className="btn btn-primary me-2"
>
  Update Registration
</Link>
 )} */}

 {getRegistration?.data?.pri_application_status === "Validate" || getRegistration?.data?.exam_status === "interviewed" ? (
  <></>
 ) : (
  <Link
    to="/updateregistration"
    state={{ getRegistration }}
    className="btn btn-primary me-2"
  >
    Update Registration
  </Link>
)}



     {/* <Link
      to=""
      className="btn btn-primary no-print"
      onClick={handleDownloadPDF}
    >
      Download
    </Link> */}

    {/* <Link
  to=""
  className="btn btn-primary no-print"
  onClick={handleDownloadPDF}
  disabled={isDownloading}
>
  {isDownloading ? (
    <>
      <i className="fa fa-spinner fa-spin me-2"></i> Downloading...
    </>
  ) : (
    "Download"
  )}
</Link> */}


  </span>
</h2>

                  </div>
                </div>
              </div>
              {/* </div>
          <div className="row"> */}
              {/* Student Information */}
              <div id="enquiry-content">
                <div className="row">
              <div className="col-xxl-3 col-xl-4 theiaStickySidebar">
                <div className="stickybar pb-4">
                  <div className="card border-white">
                    <div className="card-header">
                      <div className="row">
                        <div className="col-xxl-4 col-xl-5 col-md-6">
                          {getRegistration?.data?.upload_photo ? (
                            <img
                              src={getRegistration?.data?.upload_photo}
                              className="img-fluid rounded Parent_image1"
                              alt="img"
                            />
                          ) : (
                            <ImageWithBasePath
                              src="assets/img/student.jfif"
                              className="img-fluid Parent_image1"
                              alt="img"
                            />
                          )}
                        </div>
                        <div className="col-xxl-8 col-xl-7 col-md-6  pl-0">
                          <h5 className="mb-1 text-truncate text-truncate_1">
                            {getRegistration?.data?.student_full_name}
                          </h5>
                          {getRegistration?.data?.registration_fee_status === "paid" ? (
                            <span className="badge badge-soft-success d-inline-flex align-items-center mb-1">
                              <i className="ti ti-circle-filled fs-5 me-1" />
                              {getRegistration?.data?.registration_fee_status}
                            </span>
                          ) : (
                            <>
                              <p className="Registration_Fee">
                                Registration Fee : ₹{Automationdata?.data?.[0]?.registration_fee}
                              </p>
                              <button
                                className="btn btn-primary Registration_Fee_button"
                                type="button"
                                onClick={handleOnlinePayment}
                              >
                                Pay Now
                              </button>
                            </>
                           )}
                        </div>
                      </div>
                    </div>
                    {/* Basic Information */}
                    <div className="card-body">
                      <h5 className="mb-3">Student Information</h5>
                      <dl className="row mb-0">
                        <dt className="col-6 fw-medium text-dark mb-3">
                          Session
                        </dt>
                        <dd className="col-6 mb-3">
                          {getRegistration?.data?.session_data?.Name || getRegistration?.data?.session}
                        </dd>
                        <dt className="col-6 fw-medium text-dark mb-3">
                          Class
                        </dt>
                        <dd className="col-6 mb-3">{getRegistration?.data?.class?.Classes}</dd>
                        <dt className="col-6 fw-medium text-dark mb-3">Id</dt>
                        <dd className="col-6 mb-3">
                          {getRegistration?.data?.id}
                        </dd>
                        <dt className="col-6 fw-medium text-dark mb-3">
                          Gender
                        </dt>
                        <dd className="col-6 mb-3">
                          {getRegistration?.data?.gender}
                        </dd>
                        <dt className="col-6 fw-medium text-dark mb-3">DOB</dt>
                        <dd className="col-6 mb-3">{dateOfBirth}</dd>
                        
                        
                        <dt className="col-6 fw-medium text-dark mb-3">
                          Aadhar No.
                        </dt>
                        <dd className="col-6 mb-3">
                          {getRegistration?.data?.aadhar_no
    ? getRegistration?.data?.aadhar_no.replace(/\d(?=\d{4})/g, "X")
    : ""}
                        </dd>
                        <dt className="col-6 fw-medium text-dark mb-3">
                          Religion
                        </dt>
                        <dd className="col-6 mb-3">
                          {getRegistration?.data?.region?.name}
                        </dd>
                        {/* <dt className="col-6 fw-medium text-dark mb-3">Caste</dt>
                        <dd className="col-6 mb-3">
                          {getRegistration?.data?.cast?.category}
                        </dd> */}
                        {getRegistration?.data?.pen_number && (
                          <>
                        <dt className="col-6 fw-medium text-dark mb-3">PEN Number</dt>
                        <dd className="col-6 mb-3">
                          {getRegistration?.data?.pen_number}
                        </dd>
                        </>
                        )}
                        <dt className="col-6 fw-medium text-dark mb-3">
                          Registration Fee
                        </dt>
                        <dd className="col-6 mb-3">
                          {Automationdata?.data?.[0]?.registration_fee}
                        </dd>
                        <dt className="col-6 fw-medium text-dark mb-3">
                          Fee Status
                        </dt>
                        <dd className="col-6 mb-3">
                          {getRegistration?.data?.registration_fee_status}
                        </dd>
                        <dt className="col-6 fw-medium text-dark mb-3">
                          Payment Mode
                        </dt>
                        <dd className="col-6 mb-3">
                          {getRegistration?.data?.payment_mode}
                        </dd>
                        
                       {getRegistration?.data?.transfer_certificate_no && (
                        <>
                        <dt className="col-6 fw-medium text-dark mb-3">
                          TC No.
                        </dt>
                        <dd className="col-6 mb-3">
                          {getRegistration?.data?.transfer_certificate_no}
                        </dd>
                        </>
                       )}
                       {getRegistration?.data?.last_school_name && (
                        <>
                        <dt className="col-6 fw-medium text-dark mb-3">
                          Previous School Name
                        </dt>
                        <dd className="col-6 mb-3">
                          {getRegistration?.data?.last_school_name}
                        </dd>
                        </>
                       )}
                        
                      </dl>
                    </div>
                    {/* /Basic Information */}
                  </div>
                </div>
              </div>
              {/* /Student Information */}
              <div className="col-xxl-9 col-xl-8">
                <div className="row">
                  <div className="col-md-12">
                    {/* Parents Information */}
                    {getRegistration?.data?.father_full_name || 
           getRegistration?.data?.father_mobile_no ||
           getRegistration?.data?.father_qualification ||
           getRegistration?.data?.father_email ||
           getRegistration?.data?.father_aadhar_no ||
           getRegistration?.data?.father_date_of_birth ||
           getRegistration?.data?.father_occupation ? (
                    <div className="card">
                      <div className="card-header">
                        <h5>Father Details</h5>
                      </div>
                      <div className="card-body">
                        <div className="border rounded p-3 pb-0 mb-3">
                          <div className="row">
                            <div className="col-sm-6 col-lg-2">
                              <div className="d-flex align-items-center mb-3">
                                {getRegistration?.data?.father_photo ? (
                                  <img
                                    src={getRegistration?.data?.father_photo}
                                    className="img-fluid rounded Parent_image"
                                    alt="img"
                                  />
                                ) : (
                                  <ImageWithBasePath
                                    src="assets/img/father.jfif"
                                    className="img-fluid Parent_image"
                                    alt="img"
                                  />
                                )}
                              </div>
                            </div>
                            <div className="col-sm-6 col-lg-10">
                              <div className="row">
                                <div className="col-6 col-sm-6 col-lg-4">
                                  <div className="mb-3">
                                    <p className="text-dark fw-medium mb-1">
                                      Name
                                    </p>
                                    {getRegistration?.data?.father_full_name }
                                    <p className="text-primary">Father</p>
                                  </div>
                                </div>
                                <div className="col-6 col-sm-6 col-lg-4">
                                  <div className="mb-3">
                                    <p className="text-dark fw-medium mb-1">
                                      Phone
                                    </p>
                                    {getRegistration?.data?.father_mobile_no ? (
                                      <p>
                                        {
                                          getRegistration?.data
                                            ?.father_mobile_no
                                        }
                                      </p>
                                    ) : (
                                      <p>N/A</p>
                                    )}
                                  </div>
                                </div>
                                <div className="col-12 col-sm-6 col-lg-4">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <div className="mb-3 overflow-hidden me-3">
                                      <p className="text-dark fw-medium mb-1">
                                        Email
                                      </p>
                                      {getRegistration?.data?.father_email ? (
                                        <p className="text-truncate">
                                          {getRegistration?.data?.father_email}
                                        </p>
                                      ) : (
                                        <p className="text-truncate">N/A</p>
                                      )}
                                    </div>
                                  </div>
                                </div>
                                {/* </div>
                        <div className="row"> */}
                                <div className="col-6  col-sm-6 col-lg-4">
                                  <div className="mb-3">
                                    <h6 className="text-dark fw-medium mb-1">
                                      Aadhar No.
                                    </h6>
                                    {getRegistration?.data?.father_aadhar_no ? (
                                      <p>
                                        {getRegistration?.data?.father_aadhar_no
    ? getRegistration?.data?.father_aadhar_no.replace(/\d(?=\d{4})/g, "X")
    : ""}
                                        {/* {
                                          getRegistration?.data?.father_aadhar_no
                                        } */}
                                      </p>
                                    ) : (
                                      <p>N/A</p>
                                    )}
                                  </div>
                                </div>
                                <div className="col-6 col-sm-6 col-lg-4">
                                  <div className="mb-3">
                                    <p className="text-dark fw-medium mb-1">
                                      Qualification
                                    </p>
                                    {getRegistration?.data
                                      ?.father_qualification ? (
                                      <p>
                                        {
                                          getRegistration?.data
                                            ?.father_qualification
                                        }
                                      </p>
                                    ) : (
                                      <p>N/A</p>
                                    )}
                                  </div>
                                </div>
                                <div className="col-6 col-sm-6 col-lg-4">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <div className="mb-3 overflow-hidden me-3">
                                      <p className="text-dark fw-medium mb-1">
                                        Occupation
                                      </p>
                                      {getRegistration?.data
                                        ?.father_occupation ? (
                                        <p>
                                          {
                                            getRegistration?.data
                                              ?.father_occupation
                                          }
                                        </p>
                                      ) : (
                                        <p>N/A</p>
                                      )}
                                    </div>
                                  </div>
                                </div>
                                {/* </div>
                        <div className="row"> */}
                                <div className="col-6 col-sm-6 col-lg-4">
                                  <div className="mb-3">
                                    <h6 className="text-dark fw-medium mb-1">
                                      Company Name
                                    </h6>
                                    {getRegistration?.data
                                      ?.father_company_name ? (
                                      <p>
                                        {
                                          getRegistration?.data
                                            ?.father_company_name
                                        }
                                      </p>
                                    ) : (
                                      <p>N/A</p>
                                    )}
                                  </div>
                                </div>
                                <div className="col-6 col-sm-6 col-lg-4">
                                  <div className="mb-3">
                                    <p className="text-dark fw-medium mb-1">
                                      Company Address
                                    </p>
                                    {getRegistration?.data
                                      ?.father_company_address ? (
                                      <p>
                                        {
                                          getRegistration?.data
                                            ?.father_company_address
                                        }
                                      </p>
                                    ) : (
                                      <p>N/A</p>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
           ) : null}
                    {/* /Parents Information */}
                    {/* Mother Information */}
                    {getRegistration?.data?.mother_full_name || 
           getRegistration?.data?.mother_mobile_no ||
           getRegistration?.data?.mother_qualification ||
           getRegistration?.data?.mother_email ||
           getRegistration?.data?.mother_aadhar_no ||
           getRegistration?.data?.mother_date_of_birth ||
           getRegistration?.data?.mother_occupation ? (
                    <div className="card">
                      <div className="card-header">
                        <h5>Mother Details</h5>
                      </div>
                      <div className="card-body">
                        <div className="border rounded p-3 pb-0 mb-3">
                          <div className="row">
                            <div className="col-sm-6 col-lg-2">
                              <div className="d-flex align-items-center mb-3">
                                {getRegistration?.data?.mother_photo_upload ? (
                                  <img
                                    src={
                                      getRegistration?.data?.mother_photo_upload
                                    }
                                    className="img-fluid rounded Parent_image"
                                    alt="img"
                                  />
                                ) : (
                                  <ImageWithBasePath
                                    src="assets/img/mother.jfif"
                                    className="img-fluid Parent_image"
                                    alt="img"
                                  />
                                )}
                              </div>
                            </div>
                            <div className="col-sm-6 col-lg-10">
                              <div className="row">
                                <div className="col-6 col-sm-6 col-lg-4">
                                  <div className="mb-3">
                                    <p className="text-dark fw-medium mb-1">
                                      Name
                                    </p>
                                    {getRegistration?.data?.mother_full_name}
                                    <p className="text-primary">Mother</p>
                                  </div>
                                </div>
                                 {getRegistration?.data?.mother_mobile_no && (
                                <div className="col-6 col-sm-6 col-lg-4">
                                  <div className="mb-3">
                                    <p className="text-dark fw-medium mb-1">
                                      Phone
                                    </p>
                                    {getRegistration?.data?.mother_mobile_no ? (
                                      <p>
                                        {
                                          getRegistration?.data
                                            ?.mother_mobile_no
                                        }
                                      </p>
                                    ) : (
                                      <p>N/A</p>
                                    )}
                                  </div>
                                </div>
                                 )}
                                 {getRegistration?.data?.mother_email && (
                                <div className="col-12 col-sm-6 col-lg-4">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <div className="mb-3 overflow-hidden me-3">
                                      <p className="text-dark fw-medium mb-1">
                                        Email
                                      </p>
                                      {getRegistration?.data?.mother_email ? (
                                        <p className="text-truncate">
                                          {getRegistration?.data?.mother_email}
                                        </p>
                                      ) : (
                                        <p className="text-truncate">N/A</p>
                                      )}
                                    </div>
                                  </div>
                                </div>
                                 )}
                                 {getRegistration?.data?.mother_aadhar_no && (
                                <div className="col-6  col-sm-6 col-lg-4">
                                  <div className="mb-3">
                                    <h6 className="text-dark fw-medium mb-1">
                                      Aadhar No.
                                    </h6>
                                    {getRegistration?.data?.mother_aadhar_no ? (
                                      <p>
                                        {getRegistration?.data?.mother_aadhar_no
    ? getRegistration?.data?.mother_aadhar_no.replace(/\d(?=\d{4})/g, "X")
    : ""}
                                        
                                      </p>
                                    ) : (
                                      <p>N/A</p>
                                    )}
                                  </div>
                                </div>
                                 )}
                                 {getRegistration?.data?.mother_qualification && (
                                <div className="col-6 col-sm-6 col-lg-4">
                                  <div className="mb-3">
                                    <p className="text-dark fw-medium mb-1">
                                      Qualification
                                    </p>
                                    {getRegistration?.data?.mother_qualification ? (
                                      <p>
                                        {
                                          getRegistration?.data
                                            ?.mother_qualification
                                        }
                                      </p>
                                    ) : (
                                      <p>N/A</p>
                                    )}
                                  </div>
                                </div>
                                 )}
                                 {getRegistration?.data?.mother_occupation && (
                                <div className="col-6 col-sm-6 col-lg-4">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <div className="mb-3 overflow-hidden me-3">
                                      <p className="text-dark fw-medium mb-1">
                                        Occupation
                                      </p>
                                      {getRegistration?.data?.mother_occupation ? (
                                        <p>
                                          {
                                            getRegistration?.data
                                              ?.mother_occupation
                                          }
                                        </p>
                                      ) : (
                                        <p>N/A</p>
                                      )}
                                    </div>
                                  </div>
                                </div>
                                 )}
                                 {getRegistration?.data?.mother_company_name && (
                                <div className="col-6 col-sm-6 col-lg-4">
                                  <div className="mb-3">
                                    <h6 className="text-dark fw-medium mb-1">
                                      Company Name
                                    </h6>
                                    {getRegistration?.data
                                      ?.mother_company_name ? (
                                      <p>
                                        {getRegistration?.data?.mother_company_name}
                                      </p>
                                    ) : (
                                      <p>N/A</p>
                                    )}
                                  </div>
                                </div>
                                 )}
                                 {getRegistration?.data?.mother_company_address && (
                                <div className="col-6 col-sm-6 col-lg-4">
                                  <div className="mb-3">
                                    <p className="text-dark fw-medium mb-1">
                                      Company Address
                                    </p>
                                    {getRegistration?.data
                                      ?.mother_company_address ? (
                                      <p>
                                        {getRegistration?.data?.mother_company_address}
                                      </p>
                                    ) : (
                                      <p>N/A</p>
                                    )}
                                  </div>
                                </div>
                                 )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                                ) : null}
                    {/* /Mother Information */}
                    {/* Guardian Information */}
                    {getRegistration?.data?.guardian_name || 
           getRegistration?.data?.guardian_mobile_no ||
           getRegistration?.data?.guardian_qualification ||
           getRegistration?.data?.guardian_aadhar_no ||
           getRegistration?.data?.guardian_date_of_birth ||
           getRegistration?.data?.guardian_occupation ? (
                    <div className="card">
                      <div className="card-header">
                        <h5>Guardian Details</h5>
                      </div>
                      <div className="card-body">
                        <div className="border rounded p-3 pb-0 mb-3">
                          <div className="row">
                            <div className="col-sm-6 col-lg-2">
                              <div className="d-flex align-items-center mb-3">
                                {getRegistration?.data
                                  ?.upload_guardian_photo ? (
                                  <img
                                    src={
                                      getRegistration?.data
                                        ?.upload_guardian_photo
                                    }
                                    className="img-fluid rounded Parent_image"
                                    alt="img"
                                  />
                                ) : (
                                  <ImageWithBasePath
                                    src="assets/img/father.jfif"
                                    className="img-fluid Parent_image"
                                    alt="img"
                                  />
                                )}
                              </div>
                            </div>

                            <div className="col-sm-6 col-lg-10">
                              <div className="row">
                                {getRegistration?.data?.guardian_name && (
                                <div className="col-6 col-sm-6 col-lg-4">
                                  <div className="mb-3">
                                    <h6 className="text-truncate">
                                      <p className="text-dark fw-medium mb-1">
                                        Name
                                      </p>
                                      {getRegistration?.data?.guardian_name}
                                    </h6>
                                    <p className="text-primary">Guardian</p>
                                  </div>
                                </div>
                                )}
                                {getRegistration?.data?.guardian_mobile_no && (
                                <div className="col-6 col-sm-6 col-lg-4">
                                  <div className="mb-3">
                                    <p className="text-dark fw-medium mb-1">
                                      Phone
                                    </p>
                                    <p>
                                      {getRegistration?.data?.guardian_mobile_no}
                                    </p>
                                  </div>
                                </div>
                                )}
                                {getRegistration?.data?.guardian_relation && (
                                <div className="col-6  col-sm-6 col-lg-4">
                                  <div className="mb-3">
                                    <h6 className="text-dark fw-medium mb-1">
                                      Relation
                                    </h6>
                                    <p>
                                      {getRegistration?.data?.guardian_relation}
                                    </p>
                                  </div>
                                </div>
                                )}
                                {getRegistration?.data?.guardian_email && (
                                <div className="col-12 col-sm-6 col-lg-4">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <div className="mb-3 overflow-hidden me-3">
                                      <p className="text-dark fw-medium mb-1">
                                        Email
                                      </p>
                                      <p className="text-truncate">
                                        {getRegistration?.data?.guardian_email}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                )}
                                {getRegistration?.data?.guardian_aadhar_no && (
                                <div className="col-12 col-sm-6 col-lg-4">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <div className="mb-3 overflow-hidden me-3">
                                      <p className="text-dark fw-medium mb-1">
                                        Aadhar Number
                                      </p>
                                      <p className="text-truncate">
                                        {getRegistration?.data?.guardian_aadhar_no}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                )}
                                {getRegistration?.data?.guardian_address && (
                                <div className="col-6 col-sm-6 col-lg-4">
                                  <div className="mb-3">
                                    <p className="text-dark fw-medium mb-1">
                                      Qualification
                                    </p>
                                    <p>
                                      {getRegistration?.data?.guardian_address}
                                    </p>
                                  </div>
                                </div>
                                )}
                                {getRegistration?.data?.guardian_occupation && (
                                <div className="col-6 col-sm-6 col-lg-4">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <div className="mb-3 overflow-hidden me-3">
                                      <p className="text-dark fw-medium mb-1">
                                        Occupation
                                      </p>
                                      <p>
                                        {getRegistration?.data?.guardian_occupation}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                )}
                                {getRegistration?.data?.guardian_qualification && (
                                <div className="col-6 col-sm-6 col-lg-4">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <div className="mb-3 overflow-hidden me-3">
                                      <p className="text-dark fw-medium mb-1">
                                        Qualification
                                      </p>
                                      <p>
                                        {getRegistration?.data?.guardian_qualification}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
           ) : null}
                    {/* /Guardian Information */}
                  </div>
                  
                  {/* Address */}
                  <div className="col-xxl-12 d-flex">
                    <div className="card flex-fill">
                      <div className="card-header">
                        <h5>Address</h5>
                      </div>
                      <div className="card-body">
                        {getRegistration?.data?.contact_address && (
                        <div className="d-flex align-items-center mb-3">
                          <span className="avatar avatar-md bg-light-300 rounded me-2 flex-shrink-0 text-default">
                            <i className="ti ti-map-pin-up" />
                          </span>
                          <div>
                            <p className="text-dark fw-medium mb-1">
                              Selected Address
                            </p>
                              <p>
                                {getRegistration?.data?.contact_address}
                              </p>
                              
                          </div>
                        </div>
                        )}
                        <div className="d-flex align-items-center mb-3">
                          <span className="avatar avatar-md bg-light-300 rounded me-2 flex-shrink-0 text-default">
                            <i className="ti ti-map-pin-up" />
                          </span>
                          <div>
                            <p className="text-dark fw-medium mb-1">
                              Student Address
                            </p>
                            {getRegistration?.data?.student_aadhar_address}
                          </div>
                        </div>
                        {getRegistration?.data?.father_aadhar_address && (
                        <div className="d-flex align-items-center">
                          <span className="avatar avatar-md bg-light-300 rounded me-2 flex-shrink-0 text-default">
                            <i className="ti ti-map-pins" />
                          </span>
                          <div>
                            <p className="text-dark fw-medium mb-1">
                              Father Address :
                            </p>
                            <p>
                              {getRegistration?.data?.father_aadhar_address}
                            </p>
                          </div>
                        </div>
                        )}
                        {getRegistration?.data?.mother_aadhar_address && (
                        <div className="d-flex align-items-center">
                          <span className="avatar avatar-md bg-light-300 rounded me-2 flex-shrink-0 text-default">
                            <i className="ti ti-map-pins" />
                          </span>
                          <div>
                            <p className="text-dark fw-medium mb-1">
                              Mother Address :
                            </p>
                            <p>
                              {getRegistration?.data?.mother_aadhar_address}
                            </p>
                          </div>
                        </div>
                        )}
                        {getRegistration?.data?.guardian_aadhar_address && (
                        <div className="d-flex align-items-center">
                          <span className="avatar avatar-md bg-light-300 rounded me-2 flex-shrink-0 text-default">
                            <i className="ti ti-map-pins" />
                          </span>
                          <div>
                            <p className="text-dark fw-medium mb-1">
                              Guardian Address :
                            </p>
                            <p>
                              {getRegistration?.data?.guardian_aadhar_address}
                            </p>
                          </div>
                        </div>
                        )}
                        {getRegistration?.data?.permanent_address && (
                        <div className="d-flex align-items-center">
                          <span className="avatar avatar-md bg-light-300 rounded me-2 flex-shrink-0 text-default">
                            <i className="ti ti-map-pins" />
                          </span>
                          <div>
                            <p className="text-dark fw-medium mb-1">
                              Permanent Address :
                            </p>
                            <p>
                              {getRegistration?.data?.permanent_address}
                            </p>
                          </div>
                        </div>
                        )}
                        
                      </div>
                    </div>
                  </div>

                  {/* /Address */}
                  {/* Bank Details */}
                  <div className="col-xxl-12 d-flex">
                    <div className="card flex-fill">
                      <div className="card-header">
                        <h5>Reference Details</h5>
                      </div>
                      <div className="card-body pb-1">
                        {getRegistration?.data?.referrals?.map((referencedata, index)=> {
                            return (
                        <div className="row">
                          {referencedata?.ref_admission_no && (
                          <div className="col-md-4">
                            <div className="mb-3">
                              <p className="text-dark fw-medium mb-1">
                                Admission Number
                              </p>
                              <p>{referencedata?.ref_admission_no}
                              </p>
                            </div>
                          </div>
                              )}
                              {referencedata?.ref_employee_code && (
                          <div className="col-md-4">
                            <div className="mb-3">
                              <p className="text-dark fw-medium mb-1">
                                Employee Code
                              </p>
                              <p>{referencedata?.ref_employee_code}
                              </p>
                            </div>
                          </div>
                              )}
                              {referencedata?.ref_name && (
                          <div className="col-md-4">
                            <div className="mb-3">
                              <p className="text-dark fw-medium mb-1">
                                Reference Name
                              </p>
                              <p>{referencedata?.ref_name}
                              </p>
                            </div>
                          </div>
                              )}
                              {referencedata?.ref_contact_no && (
                          <div className="col-md-4">
                            <div className="mb-3">
                              <p className="text-dark fw-medium mb-1">
                                Mobile No.
                              </p>
                              <p>{referencedata?.ref_contact_no}
                              </p>
                            </div>
                          </div>
                              )}
                              {referencedata?.ref_role && (
                          <div className="col-md-4">
                            <div className="mb-3">
                              <p className="text-dark fw-medium mb-1">
                                Role
                              </p>
                              <p>{referencedata?.ref_role}
                              </p>
                            </div>
                          </div>
                              )}
                              {referencedata?.ref_relation && (
                          <div className="col-md-4">
                            <div className="mb-3">
                              <p className="text-dark fw-medium mb-1">
                                Relation
                              </p>
                              <p>{referencedata?.ref_relation}
                              </p>
                            </div>
                          </div>
                              )}
                              {referencedata?.ref_year_of_leaving && (
                          <div className="col-md-4">
                            <div className="mb-3">
                              <p className="text-dark fw-medium mb-1">
                                Leaving Year
                              </p>
                              <p>{referencedata?.ref_year_of_leaving}
                              </p>
                            </div>
                          </div>
                              )}
                              {referencedata?.ref_note && (
                          <div className="col-md-4">
                            <div className="mb-3">
                              <p className="text-dark fw-medium mb-1">
                                Note
                              </p>
                              <p>{referencedata?.ref_note}
                              </p>
                            </div>
                          </div>
                              )}
                        </div>
                          )})}
                      </div>
                    </div>
                  </div>
                  {/* /Bank Details */}
                  {/* Documents */}
                  <div className="col-xxl-12">
                    <div className="card">
                      <div className="card-header">
                        <h5>Documents</h5>
                      </div>

                      <div className="">
                        <div className="row">
                          {getRegistration?.data?.dob_certificate &&
            getRegistration?.data?.dob_certificate.length > 0 ? (
                          <div className="col-md-4">
                            <div className="card flex-fill">
                              <div className="card-header">
                                <h5>Birth Certificate</h5>
                              </div>
                              <div className="card-body">
                                {getRegistration?.data?.dob_certificate ? (
                                  <img
                                    src={getRegistration?.data?.dob_certificate}
                                    className="img-fluid rounded Parent_image"
                                    alt="img"
                                  />
                                ) : (
                                  <ImageWithBasePath
                                    src="assets/img/students/student-01.jpg"
                                    className="img-fluid Parent_image"
                                    alt="img"
                                  />
                                )}
                              </div>
                            </div>
                          </div>
            ) : null}
                          {getRegistration?.data?.bonafide_certificate &&
            getRegistration?.data?.bonafide_certificate.length > 0 ? (
                          <div className="col-md-4">
                            <div className="card flex-fill">
                              <div className="card-header">
                                <h5>Bonafide</h5>
                              </div>
                              <div className="card-body">
                                {getRegistration?.data?.bonafide_certificate ? (
                                  <img
                                    src={
                                      getRegistration?.data?.bonafide_certificate
                                    }
                                    className="img-fluid rounded Parent_image"
                                    alt="img"
                                  />
                                ) : (
                                  <ImageWithBasePath
                                    src="assets/img/students/student-01.jpg"
                                    className="img-fluid Parent_image"
                                    alt="img"
                                  />
                                )}
                              </div>
                            </div>
                          </div>
            ) : null}
                          {getRegistration?.data?.aadhar_file &&
            getRegistration?.data?.aadhar_file.length > 0 ? (
              <>
                          <div className="col-md-4">
                            <div className="card flex-fill">
                              <div className="card-header">
                                <h5>Aadhar Card</h5>
                              </div>
                              <div className="card-body">
                                {getRegistration?.data?.aadhar_file ? (
                                  <img
                                    src={
                                      getRegistration?.data?.aadhar_file
                                    }
                                    className="img-fluid rounded Parent_image"
                                    alt="img"
                                  />
                                ) : (
                                  <ImageWithBasePath
                                    src="assets/img/students/student-01.jpg"
                                    className="img-fluid Parent_image"
                                    alt="img"
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                          </>
            ) : null}

{getRegistration?.data?.id_proof &&
            getRegistration?.data?.id_proof.length > 0 ? (
              <>
            <div className="col-md-4">
                            <div className="card flex-fill">
                              <div className="card-header">
                                <h5>ID Proof</h5>
                              </div>
                              <div className="card-body">
                                {getRegistration?.data?.id_proof ? (
                                  <img
                                    src={getRegistration?.data?.id_proof}
                                    className="img-fluid rounded Parent_image"
                                    alt="img"
                                  />
                                ) : (
                                  <ImageWithBasePath
                                    src="assets/img/students/student-01.jpg"
                                    className="img-fluid Parent_image"
                                    alt="img"
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                          </>
            ) : null}
                          
                          {getRegistration?.data?.cast_certificate &&
            getRegistration?.data?.cast_certificate.length > 0 ? (
              
                          <div className="col-md-4">
                            <div className="card flex-fill">
                              <div className="card-header">
                                <h5>Caste Certificate</h5>
                              </div>
                              <div className="card-body">
                                {getRegistration?.data
                                  ?.cast_certificate ? (
                                  <img
                                    src={
                                      getRegistration?.data
                                        ?.cast_certificate
                                    }
                                    className="img-fluid rounded Parent_image"
                                    alt="img"
                                  />
                                ) : (
                                  <ImageWithBasePath
                                    src="assets/img/students/student-01.jpg"
                                    className="img-fluid Parent_image"
                                    alt="img"
                                  />
                                )}
                              </div>
                            </div>
                          </div>
            ) : null}

{getRegistration?.data?.tc &&
            getRegistration?.data?.tc.length > 0 ? (

                          <div className="col-md-4">
                            <div className="card flex-fill">
                              <div className="card-header">
                                <h5>Transfer Certificate</h5>
                              </div>
                              <div className="card-body">
                                {getRegistration?.data?.tc ? (
                                  <img
                                    src={getRegistration?.data?.tc}
                                    className="img-fluid rounded Parent_image"
                                    alt="img"
                                  />
                                ) : (
                                  <ImageWithBasePath
                                    src="assets/img/students/student-01.jpg"
                                    className="img-fluid Parent_image"
                                    alt="img"
                                  />
                                )}
                              </div>
                            </div>
                          </div>
            ) : null}
                          
                         
                          
                   {getRegistration?.data?.document &&
            getRegistration?.data?.document.length > 0 ? (       
                          
                          <div className="col-md-4">
                            <div className="card flex-fill">
                              <div className="card-header">
                                <h5>Other Document</h5>
                              </div>
                              <div className="card-body">
                                {getRegistration?.data?.document ? (
                                  <img
                                    src={getRegistration?.data?.document}
                                    className="img-fluid rounded Parent_image"
                                    alt="Document"
                                  />
                                ) : (
                                  <ImageWithBasePath
                                    src="assets/img/students/student-01.jpg"
                                    className="img-fluid Parent_image"
                                    alt="No Document Available"
                                  />
                                )}
                              </div>
                            </div>
                          </div>
            ) : null}
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* /Documents */}
                </div>
              </div>
              </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="content row d-flex justify-content-center align-items-center background-color_row_1">
            <Header />
            <ImageWithBasePath
              src="assets/img/nodata.gif"
              className="img-fluid"
              alt="img"
              width={200}
            />
          </div>
        )}
      </div>
      {/* /Page Wrapper */}
      {/* <StudentModals /> */}
    </>
  );
};

export default Myregistration;
